import { Component, OnInit, Input } from '@angular/core';
import { CommercialService } from '../../commercial.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';


@Component({
  selector: 'app-cq6',
  templateUrl: './cq6.component.html',
  styleUrls: ['./cq6.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq6Component implements OnInit {

  @Input() data: any;
  questions = [];
  userResponses = [];
  question;
  questionObj;
  deviceWidth;
  avg_bill;
  question_sub1;
  question_sub2;
  question_sub3;
  isChecked = false;
  bill_responses = [];
  hgAverageBills = {
    small: false,
    medium: false,
    large: false,
    industrial: false
  };
  showbutton = true;
  small_src;
  medium_src;
  large_src;
  industrial_src;
  smallavgbill_id;
  mediumavgbill_id;
  largeavgbill_id;
  industrialavgbill_id;
  user_bot;
  timer;
  showTyping = false;
  time =3000;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  typingNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({'currentId': this.data});
      this.showTyping = true;
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, this.time);
    }
  }

  ngOnInit() {
    this.small_src = 'assets/images/disabled-small-commercial.svg';
    this.medium_src = 'assets/images/disabled-medium-commercial.svg';
    this.large_src = 'assets/images/disabled-large-commercial.svg';
    this.industrial_src = 'assets/images/disabled-Industrial.svg';
    this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.smallavgbill_id = document.getElementById('small_commercial_mob');
      this.mediumavgbill_id = document.getElementById('meduim_commercial_mob');
      this.largeavgbill_id = document.getElementById('large_commercial_mob');
      this.industrialavgbill_id = document.getElementById('industrial_mob');
    } else {
      this.smallavgbill_id = document.getElementById('small_commercial');
      this.mediumavgbill_id = document.getElementById('meduim_commercial');
      this.largeavgbill_id = document.getElementById('large_commercial');
      this.industrialavgbill_id = document.getElementById('industrial');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        let index;
        if (this.commercialService.serialNumber === null) {
          index = this.bill_responses.length;
        } else {
          index = this.commercialService.serialNumber;
        }
        let street_suite = '';
        if (!_.isEmpty(this.userResponses[3])) {
          const address_components = this.userResponses[3].fieldValue[index].geoMapAddress.address_components;
          let street_number = '';
          let street_address = '';
          _.each (address_components, function(item) {
            if (item.types[0] === 'street_number') {
              street_number = item.long_name;
            } else if (item.types[0] === 'route') {
              street_address = item.long_name;
            }
          });
          // street_suite = street_number + ' ' + street_address + ' ' + this.userResponses[3].fieldValue[index].suite;
          street_suite = street_number + ' ' + street_address;
        }
        const questionName = !_.isEmpty(this.userResponses[3]) ? street_suite : '';
        this.question = this.question.replace('<enter street address>', questionName);
        if (this.deviceWidth > 768) {
          const question_sub1 = this.question.split('monthly ');
          this.question_sub1 = question_sub1[0] + 'monthly';
          const question_sub2 = question_sub1[1].split('at ');
          this.question_sub2 = question_sub2[0] + 'at';
          this.question_sub3 = question_sub2[1];
        }
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.bill_responses = obj.fieldValue;
        if (!_.isEmpty(this.bill_responses) && !this.commercialService.addAddress) {
          let index;
          if (this.commercialService.serialNumber === null) {
            index = 0;
          } else {
            index = this.commercialService.serialNumber;
          }
          if (!_.isEmpty(this.bill_responses[index])) {
            this.avg_bill = this.bill_responses[index].value;
            this.isChecked = true;
            if (this.avg_bill === 'Under $2K per month') {
              this.small_src = 'assets/images/enabled-small-commercial.svg';
              this.medium_src = 'assets/images/disabled-medium-commercial.svg';
              this.large_src = 'assets/images/disabled-large-commercial.svg';
              this.industrial_src = 'assets/images/disabled-Industrial.svg';
              this.hgAverageBills = {
                small: true,
                medium: false,
                large: false,
                industrial: false
              };
              this.smallavgbill_id.parentElement.parentElement.classList.add('active-select');
            } else if (this.avg_bill === '$2K - $10K per month') {
              this.small_src = 'assets/images/disabled-small-commercial.svg';
              this.medium_src = 'assets/images/enabled-medium-commercial.svg';
              this.large_src = 'assets/images/disabled-large-commercial.svg';
              this.industrial_src = 'assets/images/disabled-Industrial.svg';
              this.hgAverageBills = {
                small: false,
                medium: true,
                large: false,
                industrial: false
              };
              this.mediumavgbill_id.parentElement.parentElement.classList.add('active-select');
            } else if (this.avg_bill === '$10K - $20K per month') {
              this.small_src = 'assets/images/disabled-small-commercial.svg';
              this.medium_src = 'assets/images/disabled-medium-commercial.svg';
              this.large_src = 'assets/images/enabled-large-commercial.svg';
              this.industrial_src = 'assets/images/disabled-Industrial.svg';
              this.hgAverageBills = {
                small: false,
                medium: false,
                large: true,
                industrial: false
              };
              this.largeavgbill_id.parentElement.parentElement.classList.add('active-select');
            } else {
              this.small_src = 'assets/images/disabled-small-commercial.svg';
              this.medium_src = 'assets/images/disabled-medium-commercial.svg';
              this.large_src = 'assets/images/disabled-large-commercial.svg';
              this.industrial_src = 'assets/images/enabled-Industrial.svg';
              this.hgAverageBills = {
                small: false,
                medium: false,
                large: false,
                industrial: true
              };
              this.industrialavgbill_id.parentElement.parentElement.classList.add('active-select');
            }
            this.user_bot = true;
            if (this.deviceWidth < 768) {
              if (this.commercialService.modifyAddress) {
                this.typingNext();
              } else {
                this.goNext();
              }
            }
          } else {
            this.small_src = 'assets/images/disabled-small-commercial.svg';
            this.medium_src = 'assets/images/disabled-medium-commercial.svg';
            this.large_src = 'assets/images/disabled-large-commercial.svg';
            this.industrial_src = 'assets/images/disabled-Industrial.svg';
          }
        } else {
          this.small_src = 'assets/images/disabled-small-commercial.svg';
          this.medium_src = 'assets/images/disabled-medium-commercial.svg';
          this.large_src = 'assets/images/disabled-large-commercial.svg';
          this.industrial_src = 'assets/images/disabled-Industrial.svg';
        }
      } else {
        this.small_src = 'assets/images/disabled-small-commercial.svg';
        this.medium_src = 'assets/images/disabled-medium-commercial.svg';
        this.large_src = 'assets/images/disabled-large-commercial.svg';
        this.industrial_src = 'assets/images/disabled-Industrial.svg';
      }
    } else {
      this.small_src = 'assets/images/disabled-small-commercial.svg';
      this.medium_src = 'assets/images/disabled-medium-commercial.svg';
      this.large_src = 'assets/images/disabled-large-commercial.svg';
      this.industrial_src = 'assets/images/disabled-Industrial.svg';
    }

    if(!this.hgAverageBills.small && !this.hgAverageBills.medium && !this.hgAverageBills.large && !this.hgAverageBills.industrial)
    {
      this.showbutton = false;
    }

  }

  getAverageBills(event) {
    this.avg_bill = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.avg_bill === 'Under $2K per month') {
        this.small_src = 'assets/images/enabled-small-commercial.svg';
        this.medium_src = 'assets/images/disabled-medium-commercial.svg';
        this.large_src = 'assets/images/disabled-large-commercial.svg';
        this.industrial_src = 'assets/images/disabled-Industrial.svg';
        this.smallavgbill_id.parentElement.parentElement.classList.add('active-select');
        if (_.contains(this.mediumavgbill_id.parentElement.parentElement.classList, 'active-select')) {
          this.mediumavgbill_id.parentElement.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.largeavgbill_id.parentElement.parentElement.classList, 'active-select')) {
          this.largeavgbill_id.parentElement.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.industrialavgbill_id.parentElement.parentElement.classList, 'active-select')) {
          this.industrialavgbill_id.parentElement.parentElement.classList.remove('active-select');
        }
        this.hgAverageBills = {
          small: true,
          medium: false,
          large: false,
          industrial: false
        };
      } else if (this.avg_bill === '$2K - $10K per month') {
        this.small_src = 'assets/images/disabled-small-commercial.svg';
        this.medium_src = 'assets/images/enabled-medium-commercial.svg';
        this.large_src = 'assets/images/disabled-large-commercial.svg';
        this.industrial_src = 'assets/images/disabled-Industrial.svg';
        this.mediumavgbill_id.parentElement.parentElement.classList.add('active-select');
        if (_.contains(this.smallavgbill_id.parentElement.parentElement.classList, 'active-select')) {
          this.smallavgbill_id.parentElement.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.largeavgbill_id.parentElement.parentElement.classList, 'active-select')) {
          this.largeavgbill_id.parentElement.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.industrialavgbill_id.parentElement.parentElement.classList, 'active-select')) {
          this.industrialavgbill_id.parentElement.parentElement.classList.remove('active-select');
        }
        this.hgAverageBills = {
          small: false,
          medium: true,
          large: false,
          industrial: false
        };
      } else if (this.avg_bill === '$10K - $20K per month') {
        this.small_src = 'assets/images/disabled-small-commercial.svg';
        this.medium_src = 'assets/images/disabled-medium-commercial.svg';
        this.large_src = 'assets/images/enabled-large-commercial.svg';
        this.industrial_src = 'assets/images/disabled-Industrial.svg';
        this.largeavgbill_id.parentElement.parentElement.classList.add('active-select');
        if (_.contains(this.smallavgbill_id.parentElement.parentElement.classList, 'active-select')) {
          this.smallavgbill_id.parentElement.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.mediumavgbill_id.parentElement.parentElement.classList, 'active-select')) {
          this.mediumavgbill_id.parentElement.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.industrialavgbill_id.parentElement.parentElement.classList, 'active-select')) {
          this.industrialavgbill_id.parentElement.parentElement.classList.remove('active-select');
        }
        this.hgAverageBills = {
          small: false,
          medium: false,
          large: true,
          industrial: false
        };
      } else {
        this.small_src = 'assets/images/disabled-small-commercial.svg';
        this.medium_src = 'assets/images/disabled-medium-commercial.svg';
        this.large_src = 'assets/images/disabled-large-commercial.svg';
        this.industrial_src = 'assets/images/enabled-Industrial.svg';
        this.industrialavgbill_id.parentElement.parentElement.classList.add('active-select');
        if (_.contains(this.smallavgbill_id.parentElement.parentElement.classList, 'active-select')) {
          this.smallavgbill_id.parentElement.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.mediumavgbill_id.parentElement.parentElement.classList, 'active-select')) {
          this.mediumavgbill_id.parentElement.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.largeavgbill_id.parentElement.parentElement.classList, 'active-select')) {
          this.largeavgbill_id.parentElement.parentElement.classList.remove('active-select');
        }
        this.hgAverageBills = {
          small: false,
          medium: false,
          large: false,
          industrial: true
        };
      }
      this.user_bot = true;
      if (this.deviceWidth < 768) {
        this.goNext();
      }
    } else {
      this.small_src = 'assets/images/disabled-small-commercial.svg';
      this.medium_src = 'assets/images/disabled-medium-commercial.svg';
      this.large_src = 'assets/images/disabled-large-commercial.svg';
      this.industrial_src = 'assets/images/disabled-Industrial.svg';
      this.hgAverageBills = {
        small: false,
        medium: false,
        large: false,
        industrial: false
      };
      this.avg_bill = '';
      this.user_bot = false;
      if (_.contains(this.smallavgbill_id.parentElement.parentElement.classList, 'active-select')) {
        this.smallavgbill_id.parentElement.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.mediumavgbill_id.parentElement.parentElement.classList, 'active-select')) {
        this.mediumavgbill_id.parentElement.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.largeavgbill_id.parentElement.parentElement.classList, 'active-select')) {
        this.largeavgbill_id.parentElement.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.industrialavgbill_id.parentElement.parentElement.classList, 'active-select')) {
        this.industrialavgbill_id.parentElement.parentElement.classList.remove('active-select');
      }
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    }

    if (this.isChecked === true)
    {
      if (this.deviceWidth < 768) {
       
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
  
      }

    }
  }

  next() {
    if (_.isEmpty(this.avg_bill)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      if (this.commercialService.serialNumber !== null) {
        this.bill_responses[this.commercialService.serialNumber] = {'serialNo': this.commercialService.serialNumber + 1, 'value': this.avg_bill};
      } else if (this.commercialService.serialNumber === null) {
        this.bill_responses.push({'serialNo': this.bill_responses.length, 'value': this.avg_bill});
      }
      const Obj = {
        'com_question_id': this.data,
        'fieldName': 'avg_bill',
        'fieldValue': this.bill_responses
      };
      this.commercialService.updateResponses(Obj);
      this.commercialService.messageService({ 'currentId': this.data });
    }
  }

}
